import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly disabled: boolean;
}

export const Disabler: React.FC<Props> = (props: Props): React.ReactElement => {
  const { disabled } = props;
  const ref = React.useRef<HTMLDivElement>(null);

  if (disabled) {
    return <Box ref={ref} sx={styles.container} />;
  } else {
    return <></>;
  }
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'inherit',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: Number.MAX_SAFE_INTEGER,
  },
};
